class WtUrls {
  constructor() {
    // URLs
    this.localUI_URL = 'http://localhost:3000'
    this.localLiveUI_URL = 'https://whatstool-new-testing.web.app'
    this.productionUI_URL = 'https://whatstool.business'
    this.imageBaseUrl = "https://whatstool.in/wtb_files/images"

    this.loginUrl = "/login";
    this.changePasswordWithEmailUrl = "/change-password-with-email";
    this.forgotPasswordUrl = "/forgot-password";
    this.signupUrl = "/signup";
    this.signupSuccessUrl = "/signup-success";
    this.emailVerificationUrl = "/email-verification";
    this.whatsappVerificationUrl = "/whatsapp-verification";
    this.otpVerificationUrl = "/otp-verification";
    this.dashboardUrl = "/app";

    this.profileUrl = "/app/profile";
    this.profileChangePasswordUrl = "/app/profile/change-password";

    this.paymentPlanSubscriptionUrl = "/app/payment/plan-subscription";
    this.paymentAddOnsUrl = "/app/payment/add-ons";
    this.paymentSummaryUrl = "/app/payment/summary";

    this.wtdPaymentUrl = "/wtd-payment";

    this.whastsappchatbuttonUrl = "/whatsapp-chat-button";
    this.whatsappLinkGeneratorUrl = "/whatsapp-link-generator";
    this.whatsappMessageTemplateUrl = "/message-template"
    this.WhatsToolPricingCalcultorUrl = "/pricing-calculator"
    this.featuredTemplatesUrl = '/featured-chatbot-templates'

    this.paymentUrl = "/app/payment";
    this.paymentCompletionUrl = "/app/completion";
    this.paymentSuccessUrl = "/app/payment-success";
    this.paymentFailedUrl = "/app/payment-failed";
    this.chatUrl = "/app/chat";
    this.ChatbotListUrl = "/app/chatbot-list";
    this.buildChatbotsUrl = "/app/build-chatbots";
    this.contactsUrl = "/app/contacts";
    this.broadcastUrl = "/app/broadcast";
    this.broadcastCreateUrl = "/app/broadcast-create";
    this.analyticsUrl = "/app/analytics";
    this.settingsUrl = "/app/settings";
    this.businessInformationUrl = "/app/settings/business-information";
    this.channelUrl = "/app/settings/channels";
    this.agentsUrl = "/app/settings/agents";
    this.labelsUrl = "/app/settings/labels";
    this.customFieldsUrl = "/app/settings/custom-fields";
    this.quickReplyUrl = "/app/settings/quick-reply";
    this.templateUrl = "/app/settings/templates";
    this.mediaUrl = "/app/settings/media";
    this.apiIntegrationUrl = "/app/settings/api-integration";
    this.appIntegrationUrl = "/app/settings/app-integration";
    this.testingUrl = "/app/testing";

    // Static Pages URls
    this.whatsappBusinessApiUrl = "/whatsApp-business-api";
    this.crmUrl = "/crm";
    this.intergrationUrl = "/integration";
    this.educationalSectorUrl = "/industry/educational-sector-industry";
    this.ecommerceSectorUrl = "/industry/ecommerce-sector-industry";
    this.healthSectorUrl = "/industry/health-sector-industry";
    this.tourTravelSectorUrl = "/industry/tour-travel-sector-industry";
    this.pricingUrl = "/pricing";

    this.teamPageUrl = '/team'
    this.conversationalEngagementUrl = '/conversational-engagement'

    this.quickGuideUrl = "/quick-guide";
    this.chatbotsUrl = "/chatbots";
    this.multiAgentsUrl = "/multi-agents";
    this.broadcastMessageUrl = "/broadcast-message";
    this.clientsUrl = "/clients";

    this.supportUrl = "/support";
    this.contactUsUrl = "/contact-us";
    this.termsOfServiceUrl = "/terms-of-service";
    this.privacyPolicyUrl = "/privacy-policy";
    this.cancellationUrl = "/cancellation";
  }
}
export const WtUrl = new WtUrls();
